<template><div class="embedded-access" role="status">{{ error || '正在接入平台登录信息…' }}</div></template>
<script>
import store from '@/store'
export default {
  data: () => ({ error: '' }),
  mounted () {
    let origin
    try { origin = new URL(this.$route.query.parentOrigin).origin } catch (error) { this.error = '平台来源无效'; return }
    if (!/^https?:/.test(origin)) { this.error = '平台来源无效'; return }
    if (window.parent === window) { this.error = '请从平台菜单打开此页面'; return }
    const nonce = Array.from(window.crypto.getRandomValues(new Uint32Array(4))).map(value => value.toString(16)).join('-')
    this.receiver = async event => {
      if (event.source !== window.parent || event.origin !== origin || !event.data || event.data.type !== 'visualization-login' || event.data.nonce !== nonce || typeof event.data.token !== 'string' || !event.data.token) return
      window.removeEventListener('message', this.receiver)
      const id = this.$route.params.id
      try {
        await store.dispatch('auth/clearPermissions')
        if (this._isDestroyed || this.$route.name !== 'screen-embedded' || this.$route.params.id !== id) return
        await store.dispatch('user/logout')
        if (this._isDestroyed || this.$route.name !== 'screen-embedded' || this.$route.params.id !== id) return
        localStorage.setItem('x-access-token', event.data.token)
        await this.$router.replace({ name: 'view', params: { id }, query: { embedded: '1' } })
      } catch (error) { if (!this._isDestroyed) this.error = error.message || '平台运行页面打开失败' }
    }
    window.addEventListener('message', this.receiver)
    window.parent.postMessage({ type: 'visualization-ready', nonce }, origin)
  },
  beforeDestroy () { window.removeEventListener('message', this.receiver) }
}
</script>
<style>.embedded-access { padding: 24px; color: #ddd; background: #0b151d; min-height: 100vh; box-sizing: border-box; }</style>
